import Fade from '@mui/material/Fade';
import { ReactNode, useEffect, useState } from 'react';

type AnimatedTransitionProps = {
  children: ReactNode;
  timeout?: number;
  className?: string;
  inPropParam?: boolean;
};

export const AnimatedTransition = ({
  children,
  timeout = 500,
  className,
  inPropParam,
}: AnimatedTransitionProps) => {
  const [inProp, setInProp] = useState(false);

  useEffect(() => {
    setInProp(true);
  }, []);

  return (
    <Fade in={inPropParam || inProp} timeout={timeout} style={{ height: '100%' }}>
      <div className={className}>{children}</div>
    </Fade>
  );
};
